import { useState } from 'react';
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const MemberAdvancedSearchExportAddressLabels = ({ isMainMember, onNameConfigChanged }) => {
  const { t } = useTranslation(['member']);

  const [nameConfigValue, setNameConfigValue] = useState('0');

  const nameConfigChanged = (event) => {
    setNameConfigValue(event.target.value);

    if (onNameConfigChanged) onNameConfigChanged(event.target.value);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <FormControl style={{ margin: '20px' }}>
        <FormLabel id='country-radio-group-label'>Namnkonfiguration</FormLabel>

        <RadioGroup aria-labelledby='country-radio-group-label' name='countries' value={nameConfigValue} onChange={nameConfigChanged}>
          <FormControlLabel value='0' control={<Radio />} label='Ingen konfiguration' />

          <FormControlLabel
            value='1'
            control={<Radio disabled={!isMainMember} />}
            label={
              <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                Lägg till familjemedlemmens namn under huvudmedlemmens namn
                <Tooltip title='Detta val är endast tillgängligt om knappen Huvudmedlem är vald när man söker medlemmar'>
                  <InfoOutlinedIcon fontSize='small' color='action' />
                </Tooltip>
              </Box>
            }
          />

          <FormControlLabel
            value='2'
            control={<Radio disabled={!isMainMember} />}
            label={
              <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                Lägg till &quot;med familj&quot; under huvudmedlemmens namn
                <Tooltip title='Detta val är endast tillgängligt om knappen Huvudmedlem är vald när man söker medlemmar'>
                  <InfoOutlinedIcon fontSize='small' color='action' />
                </Tooltip>
              </Box>
            }
          />

          <FormControlLabel
            value='3'
            control={<Radio />}
            label={
              <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                Lägg till &quot;Till målsman för&quot; ovanför medlemmens namn
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
};
